import { useState,useEffect } from "react";
import { motion, AnimatePresence  } from "framer-motion";
import { BookOpen, Eye, User, FileText, Calendar, Users, Phone, Search, ChevronLeft, ChevronRight, ArrowRight, GraduationCap, Sparkles } from "lucide-react";
import axios from "axios";

export default function AlumniPage({ 
  accent = "#115e32",
  pageTitle = "Office of Career Services and Alumni Relations (OCSAR) | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  const tabs = [
    { id: "about", label: "About OCSAR", icon: <BookOpen size={18} /> },
    { id: "vision", label: "Vision and Mission", icon: <Eye size={18} /> },
    { id: "message", label: "Message from the Director, OCSAR", icon: <User size={18} /> },
    { id: "services", label: "Program and Services", icon: <FileText size={18} /> },
    { id: "registration", label: "Alumni Registration", icon: <Calendar size={18} /> },
    { id: "directory", label: "Alumni Directory", icon: <Users size={18} /> },
	{ id: "news", label: "Alumni News", icon: <FileText size={18} /> },
	{ id: "team", label: "OCSAR Team", icon: <User size={18} /> },
    { id: "contact", label: "Contact OCSAR", icon: <Phone size={18} /> },
  ];

	const [activeTab, setActiveTab] = useState("about");
	const [step, setStep] = useState(1);
	const [loading, setLoading] = useState(false);
	const [message, setMessage] = useState(null);
	const [messageType, setMessageType] = useState(""); // success | error
	const [form, setForm] = useState({
		token: "",
		studentId: "",
		studentName: "",
		cgpa: "",
		email: "",
		mobile: "",
		dob: "",
		presentAddress: "",
		profession: "",
		companyName: "",
		designation: "",
		companyAddress: "",
		picture: null,
	});
	
	const [alumni, setAlumni] = useState([]);
	const [filtered, setFiltered] = useState([]);
	const [search, setSearch] = useState("");
	const [page, setPage] = useState(1);
	const [limit] = useState(12); // cards per page
	const [error, setError] = useState(null);
	const fetchStudentName = async (id) => {
		if (!id) return;
		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,	
				matric_no:id,
			};
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const res = await api.post("/name", payload);
			if (res.data?.name) {
				setForm((prev) => ({ ...prev, studentName: res.data.name || "" }));
			}else {
				setMessageType("error");
				setMessage("Invalid Student ID");
			}
		} catch {
			setForm((prev) => ({ ...prev, studentName: "" }));
		}
    };

	const handleChange = (e) => {
		const { name, value, files } = e.target;
		if (name === "picture") {
		  setForm((prev) => ({ ...prev, picture: files[0] }));
		} else {
		  setForm((prev) => ({ ...prev, [name]: value }));
		}
	};

  // Step 1: Take a Token
	const handleStepOneSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				matric_no: form.studentId,
				studentName: form.studentName,
				cgpa: form.cgpa,
				email: form.email,
				mobile: form.mobile,
			};
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const res = await api.post("/alumni-token", payload);
			const { responseCode, responseMsg } = res.data;
			
			if (responseCode === "200") {
				setMessageType("success");
				setMessage(responseMsg);
				alert("Token has been sent to your Email/Mobile. Please check your inbox.");
				setStep(2);
			} else {
				setMessageType("error");
				setMessage(responseMsg);
			}	
			
		} catch {
		    setMessageType("error");
			setMessage("Server error. Please try again.");
		} finally {
		  setLoading(false);
		}
	};

  // Step 2: Complete Registration
	const handleStepTwoSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		const formData = new FormData();
		Object.entries(form).forEach(([k, v]) => formData.append(k, v));

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				token: form.token,
				studentId: form.studentId,
				studentName: form.studentName,
				cgpa: form.cgpa,
				email: form.email,
				mobile: form.mobile,
				dob: form.dob,
				presentAddress: form.presentAddress,
				profession: form.profession,
				companyName: form.companyName,
				designation: form.designation,
				companyAddress: form.companyAddress,
				picture: form.picture,
			};
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "multipart/form-data" },
			});
			const res = await api.post("/alumni-registration", payload);
			const { responseCode, responseMsg } = res.data;
			
			if (responseCode === "200") {
				setMessageType("success");
				setMessage("Registration completed successfully!");
				setForm({
					token: "",
					studentId: "",
					studentName: "",
					cgpa: "",
					email: "",
					mobile: "",
					dob: "",
					presentAddress: "",
					profession: "",
					companyName: "",
					designation: "",
					companyAddress: "",
					picture: null,
				});
			} else {
				setMessageType("error");
				setMessage(responseMsg);
			}
		} catch {
		  setMessageType("error");
		  setMessage("Registration failed. Please try again.");
		} finally {
		  setLoading(false);
		}
	};
	const alumniPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,				
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/alumni-directory", payload);
			
			// Loop data (array)
			setAlumni(response.data || []);
			setFiltered(response.data || []);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	useEffect(() => {
		alumniPost();		
	}, []);
	
	useEffect(() => {
		const q = search.toLowerCase();
		const result = alumni.filter(
		  (a) =>
			a.name.toLowerCase().includes(q) ||
			a.department.toLowerCase().includes(q) ||
			a.companyName.toLowerCase().includes(q)
		);
		setFiltered(result);
		setPage(1);
	}, [search, alumni]);
	
	const totalPages = Math.ceil(filtered.length / limit);
	const currentData = filtered.slice((page - 1) * limit, page * limit);

	const nextPage = () => setPage((p) => Math.min(p + 1, totalPages));
	const prevPage = () => setPage((p) => Math.max(p - 1, 1));
	
  const inputClass =
    "w-full p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-yellow-400";
  const content = {
    about: (
      <p> 
		<strong>About OCSAR</strong><br/>
		UCTC Office of Career Services and Alumni Relations (OCSAR) is a dedicated department, vested with the duty to facilitate its students’ efficient and effective transition into their professional life which will ultimately lead to successful career for them.
		<br/><br/>
		OCSAR is a platform where students are prepared to end their academic journey and begin a new journey as proud alumni of UCTC .
	  </p>
    ),
    vision: (
      <p>
        <strong>Mission:</strong><br/>
		OCSAR’s vision is to empower students and alumni to achieve success in the ‘world of work’ and ensure that they have the right competencies, skills set and overall approach for professional success.
		
		<br/><br/><strong>Vision:</strong><br/>
		Mission of OCSAR is to provide an integrated range of high quality career-focused services which meet the needs of our graduating students and prepares them for professional success. We aspire to create well rounded, socially aware, responsible human beings and conscious citizens.
		</p>
    ),
    message: (
      <p>
		<strong>Message from the Director, OCSAR</strong><br/>
        Welcome to the Office of Career Services & Alumni Relations (OCSAR) of University of Creative Technology Chittagong (UCTC). The OCSAR’s commitment to you is lifelong. Whether you are an undergraduate, an alumnus, the Office of Career Services & Alumni Relations (OCSAR) is eager to help you achieve your goals. You will find that our staffs, programs, and resources are ready to support you in the best possible way we can. We look forward to assist students and alumni with career exploration and professional development.
      </p>
    ),
    services: (
		<div className="w-full animate-fadeInRight">
            <img
              src="/img/program-service-ocsar.png"
              alt="UCTC Illustration"
              className="w-[100%] mx-auto drop-shadow-xl object-cover"
            />
        </div>
    ),
    registration: (
      <div className="relative isolate w-full overflow-hidden rounded-3xl bg-gradient-to-br from-sky-50 via-white to-cyan-50 p-3 sm:p-6 lg:p-8">
        {/* Decorative background */}
        <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-cyan-200/40 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-20 -left-16 h-56 w-56 rounded-full bg-sky-200/40 blur-3xl" />

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
          className="relative mx-auto w-full max-w-4xl overflow-hidden rounded-2xl border border-white/80 bg-white shadow-xl shadow-sky-900/10"
        >
          {/* Registration header */}
          <div className="bg-gradient-to-r from-[#014864] to-[#0b7894] px-5 py-6 text-white sm:px-8 sm:py-8">
            <div className="flex items-center gap-3">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white/15 ring-1 ring-white/20">
                <GraduationCap size={25} />
              </div>
              <div className="min-w-0">
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-cyan-100">
                  UCTC Alumni Network
                </p>
                <h2 className="mt-1 text-xl font-extrabold sm:text-2xl">
                  Alumni Registration
                </h2>
                <p className="mt-1 text-sm text-sky-100">
                  Stay connected with your university and fellow alumni.
                </p>
              </div>
            </div>

            {/* Step indicator */}
            <div className="mt-7 grid grid-cols-2 gap-3">
              {[
                { number: 1, label: "Verify & Get Token" },
                { number: 2, label: "Complete Profile" },
              ].map((item) => {
                const current = step === item.number;
                const completed = step > item.number;
                return (
                  <div key={item.number} className="flex items-center gap-2">
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold ${
                        current || completed
                          ? "bg-white text-[#014864]"
                          : "border border-white/40 bg-white/10 text-white"
                      }`}
                    >
                      {completed ? "✓" : item.number}
                    </span>
                    <span
                      className={`text-xs font-semibold sm:text-sm ${
                        current ? "text-white" : "text-sky-100/80"
                      }`}
                    >
                      {item.label}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="p-4 sm:p-7 lg:p-8">
            <div className="mb-6">
              <h3 className="text-lg font-bold text-slate-800 sm:text-xl">
                {step === 1 ? "Start your alumni journey" : "Complete your alumni profile"}
              </h3>
              <p className="mt-1 text-sm leading-6 text-slate-500">
                {step === 1
                  ? "Enter your academic and contact details to receive a verification token."
                  : "Enter the token you received and provide your current personal and professional information."}
              </p>
            </div>

            {message && (
              <div
                role="alert"
                className={`mb-5 flex items-start gap-3 rounded-xl border p-3 text-sm ${
                  messageType === "success"
                    ? "border-emerald-200 bg-emerald-50 text-emerald-800"
                    : "border-rose-200 bg-rose-50 text-rose-700"
                }`}
              >
                <span className="font-bold">{messageType === "success" ? "✓" : "!"}</span>
                <span>{message}</span>
              </div>
            )}

            <AnimatePresence mode="wait">
              {step === 1 ? (
                <motion.form
                  key="step1"
                  onSubmit={handleStepOneSubmit}
                  initial={{ opacity: 0, x: -18 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 18 }}
                  transition={{ duration: 0.25 }}
                  className="space-y-5"
                >
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div>
                      <label className="mb-1.5 block text-sm font-semibold text-slate-700">
                        Student ID <span className="text-rose-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="studentId"
                        value={form.studentId}
                        onChange={(e) => {
                          handleChange(e);
                          fetchStudentName(e.target.value);
                        }}
                        placeholder="Enter your student ID"
                        className={inputClass}
                        required
                      />
                    </div>
                    <div>
                      <label className="mb-1.5 block text-sm font-semibold text-slate-700">
                        Student Name <span className="text-rose-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="studentName"
                        value={form.studentName}
                        className={`${inputClass} bg-slate-50 text-slate-500`}
                        placeholder="Auto-filled from student ID"
                        readOnly
                        required
                      />
                    </div>
                    <div>
                      <label className="mb-1.5 block text-sm font-semibold text-slate-700">
                        CGPA <span className="text-rose-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="cgpa"
                        value={form.cgpa}
                        onChange={handleChange}
                        placeholder="Your final CGPA"
                        className={inputClass}
                        required
                      />
                    </div>
                    <div>
                      <label className="mb-1.5 block text-sm font-semibold text-slate-700">
                        Email Address <span className="text-rose-500">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        placeholder="name@example.com"
                        className={inputClass}
                        required
                      />
                    </div>
                    <div className="sm:col-span-2">
                      <label className="mb-1.5 block text-sm font-semibold text-slate-700">
                        Mobile Number <span className="text-rose-500">*</span>
                      </label>
                      <input
                        type="tel"
                        name="mobile"
                        value={form.mobile}
                        onChange={handleChange}
                        maxLength={11}
                        pattern="\d{11}"
                        inputMode="numeric"
                        placeholder="01XXXXXXXXX"
                        className={inputClass}
                        required
                      />
                      <p className="mt-1.5 text-xs text-slate-400">
                        Enter an 11-digit mobile number.
                      </p>
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="group flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#014864] to-[#0b7894] px-5 py-3.5 font-bold text-white shadow-lg shadow-cyan-900/15 transition hover:-translate-y-0.5 hover:shadow-xl disabled:cursor-not-allowed disabled:opacity-60"
                  >
                    {loading ? "Sending Token..." : "Send Verification Token"}
                    {!loading && <ArrowRight size={18} className="transition group-hover:translate-x-1" />}
                  </button>
                </motion.form>
              ) : (
                <motion.form
                  key="step2"
                  onSubmit={handleStepTwoSubmit}
                  initial={{ opacity: 0, x: 18 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -18 }}
                  transition={{ duration: 0.25 }}
                  className="space-y-5"
                >
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    {[
                      {
                        name: "token",
                        label: "Verification Token",
                        type: "text",
                        placeholder: "Enter the token received",
                        required: true,
                      },
                      {
                        name: "studentId",
                        label: "Student ID",
                        type: "text",
                        placeholder: "Enter your student ID",
                        required: true,
                      },
                      {
                        name: "studentName",
                        label: "Student Name",
                        type: "text",
                        placeholder: "Auto-filled from student ID",
                        required: true,
                        readOnly: true,
                      },
                      {
                        name: "cgpa",
                        label: "CGPA",
                        type: "text",
                        placeholder: "Your final CGPA",
                        required: true,
                      },
                      {
                        name: "dob",
                        label: "Date of Birth",
                        type: "date",
                        required: true,
                      },
                      {
                        name: "mobile",
                        label: "Mobile Number",
                        type: "tel",
                        placeholder: "01XXXXXXXXX",
                        required: true,
                        maxLength: 11,
                        pattern: "\\d{11}",
                      },
                      {
                        name: "email",
                        label: "Email Address",
                        type: "email",
                        placeholder: "name@example.com",
                        required: true,
                      },
                      {
                        name: "profession",
                        label: "Profession",
                        type: "text",
                        placeholder: "Your profession",
                        required: true,
                      },
                      {
                        name: "companyName",
                        label: "Present Company Name",
                        type: "text",
                        placeholder: "Company / organization",
                      },
                      {
                        name: "designation",
                        label: "Designation",
                        type: "text",
                        placeholder: "Your designation",
                      },
                    ].map((field) => (
                      <div key={field.name}>
                        <label className="mb-1.5 block text-sm font-semibold text-slate-700">
                          {field.label} {field.required && <span className="text-rose-500">*</span>}
                        </label>
                        <input
                          type={field.type}
                          name={field.name}
                          value={form[field.name]}
                          onChange={
                            field.name === "studentId"
                              ? (e) => {
                                  handleChange(e);
                                  fetchStudentName(e.target.value);
                                }
                              : handleChange
                          }
                          placeholder={field.placeholder}
                          maxLength={field.maxLength}
                          pattern={field.pattern}
                          readOnly={field.readOnly}
                          inputMode={field.name === "mobile" ? "numeric" : undefined}
                          className={`${inputClass} ${
                            field.readOnly ? "bg-slate-50 text-slate-500" : ""
                          }`}
                          required={field.required}
                        />
                      </div>
                    ))}

                    <div>
                      <label className="mb-1.5 block text-sm font-semibold text-slate-700">
                        Present Address <span className="text-rose-500">*</span>
                      </label>
                      <textarea
                        name="presentAddress"
                        value={form.presentAddress}
                        onChange={handleChange}
                        placeholder="Your current address"
                        rows={3}
                        className={`${inputClass} resize-y`}
                        required
                      />
                    </div>
                    <div>
                      <label className="mb-1.5 block text-sm font-semibold text-slate-700">
                        Company Address
                      </label>
                      <textarea
                        name="companyAddress"
                        value={form.companyAddress}
                        onChange={handleChange}
                        placeholder="Company address (optional)"
                        rows={3}
                        className={`${inputClass} resize-y`}
                      />
                    </div>
                    <div className="sm:col-span-2">
                      <label className="mb-1.5 block text-sm font-semibold text-slate-700">
                        Upload Picture <span className="text-rose-500">*</span>
                      </label>
                      <input
                        type="file"
                        name="picture"
                        accept="image/*"
                        onChange={handleChange}
                        className={`${inputClass} file:mr-3 file:rounded-lg file:border-0 file:bg-cyan-50 file:px-3 file:py-2 file:text-sm file:font-semibold file:text-[#014864]`}
                        required
                      />
                      <p className="mt-1.5 text-xs text-slate-400">
                        Choose a clear profile photo.
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col-reverse gap-3 border-t border-slate-100 pt-5 sm:flex-row">
                    <button
                      type="button"
                      onClick={() => setStep(1)}
                      className="flex w-full items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-5 py-3.5 font-semibold text-slate-600 transition hover:bg-slate-50 sm:w-1/3"
                    >
                      <ChevronLeft size={18} />
                      Back
                    </button>
                    <button
                      type="submit"
                      disabled={loading}
                      className="flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#014864] to-[#0b7894] px-5 py-3.5 font-bold text-white shadow-lg shadow-cyan-900/15 transition hover:-translate-y-0.5 hover:shadow-xl disabled:cursor-not-allowed disabled:opacity-60 sm:flex-1"
                    >
                      {loading ? "Submitting..." : "Complete Registration"}
                      {!loading && <ArrowRight size={18} />}
                    </button>
                  </div>
                </motion.form>
              )}
            </AnimatePresence>
          </div>
        </motion.div>
      </div>
    ),
    directory: (
      <section className="max-w-7xl mx-auto px-6 py-12">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-3xl font-bold text-center mb-6 text-gray-800"
      >
        Alumni Directory
      </motion.h2>

      {/* Search Bar */}
      <div className="flex justify-center mb-8">
        <div className="relative w-full max-w-md">
          <Search className="absolute left-3 top-2.5 text-gray-400" />
          <input
            type="text"
            placeholder="Search by name, department, or company..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full border border-gray-300 rounded-full py-2 pl-10 pr-4 focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
        </div>
      </div>

      {/* Alumni Grid */}
      {loading ? (
        <p className="text-center text-gray-500">Loading alumni data...</p>
      ) : filtered.length === 0 ? (
        <p className="text-center text-gray-500">No alumni found.</p>
      ) : (
        <motion.div
		  layout
		  className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6"
		>
		  {currentData.map((a, idx) => (
			<motion.div
			  key={a.id || idx}
			  initial={{ opacity: 0, y: 20 }}
			  animate={{ opacity: 1, y: 0 }}
			  transition={{ delay: idx * 0.05 }}
			  className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300"
			>
			  {/* Image Section */}
			  <div className="aspect-[4/5] w-full bg-gray-100 flex items-center justify-center p-2">
				<img
				  src={
					a.picture
					  ? `${import.meta.env.VITE_API_SOURCE_URL}${a.picture}`
					  : "/default-profile.png"
				  }
				  alt={a.name}
				  className="w-full h-full object-contain"
				  onError={(e) => {
					e.target.src = "/default-profile.png";
				  }}
				/>
			  </div>

			  {/* Content Section */}
			  <div className="p-4">
				<h3 className="font-semibold text-lg text-gray-800">
				  {a.name}
				</h3>

				<p className="text-sm text-gray-500">
				  {a.matric_no}
				</p>

				<p className="text-sm text-gray-500 mb-3">
				  {a.department_name}
				</p>

				<div className="space-y-1">
				  <p className="text-sm text-gray-700">
					<span className="font-semibold">Profession:</span>{" "}
					{a.profession || "N/A"}
				  </p>

				  <p className="text-sm text-gray-700">
					<span className="font-semibold">Company:</span>{" "}
					{a.company_name || "N/A"}
				  </p>

				  <p className="text-sm text-gray-700">
					<span className="font-semibold">Designation:</span>{" "}
					{a.designation || "N/A"}
				  </p>
				</div>
			  </div>
			</motion.div>
		  ))}
		</motion.div>
      )}

      {/* Pagination */}
      {filtered.length > limit && (
        <div className="flex justify-center items-center mt-8 space-x-3">
          <button
            onClick={prevPage}
            disabled={page === 1}
            className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          >
            <ChevronLeft />
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              onClick={() => setPage(i + 1)}
              className={`px-4 py-1 rounded-full text-sm ${
                page === i + 1
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={nextPage}
            disabled={page === totalPages}
            className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          >
            <ChevronRight />
          </button>
        </div>
      )}
    </section>
    ),
	news: (
      <p>
       </p>
    ),
	team: (
      <p>
       </p>
    ),
    contact: (
      <p>
		<strong>Contact Office of Career Services and Alumni Relations (OCSAR) to the following;;</strong><br/>
		<strong>Location:</strong> 1st Floor, UCTC Campus<br/>
		<strong>Hours:</strong> Monday through Saturday, 9.00 AM to 6.00 PM<br/>
        <strong>Email:</strong> ocsar@uctc.edu.bd <br />
        <strong>Phone:</strong> 8801707507071 <br />
        <strong>Mailing Address:</strong> Student Affairs Division, University of Creative Technology, Chittagong, 1084, Near New Chandgaon Police Station, Shah Amanat Bridge Connecting Road, Bahaddarhat, Chittagong, Bangladesh
      </p>
    ),
  };

  return (
    <div className="min-h-screen overflow-hidden bg-slate-50 text-slate-800">
      {/* Animated OCSAR Hero */}
      <section className="relative isolate overflow-hidden bg-gradient-to-br from-[#014864] via-[#075b78] to-[#0b7894] px-5 py-16 text-white sm:px-8 md:py-24">
        <div className="pointer-events-none absolute inset-0 opacity-20">
          <div className="absolute -left-20 -top-24 h-72 w-72 rounded-full bg-cyan-300 blur-3xl" />
          <div className="absolute -right-16 bottom-0 h-96 w-96 rounded-full bg-sky-400 blur-3xl" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(255,255,255,0.18)_1px,transparent_0)] [background-size:28px_28px]" />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="relative mx-auto max-w-7xl"
        >
          <div className="mx-auto max-w-4xl text-center">
            <motion.div
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.15, duration: 0.5 }}
              className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-2 text-sm font-semibold text-cyan-100 backdrop-blur"
            >
              <Sparkles size={16} />
              UCTC • Career Services & Alumni Relations
            </motion.div>

            <h1 className="text-balance text-3xl font-extrabold leading-tight sm:text-4xl md:text-6xl">
              Office of Career Services
              <span className="mt-2 block text-cyan-200">
                and Alumni Relations (OCSAR)
              </span>
            </h1>

            <p className="mx-auto mt-6 max-w-2xl text-base leading-7 text-sky-100 sm:text-lg">
              Supporting students’ academic journey, professional growth,
              leadership, and lifelong connection with UCTC.
            </p>

            <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row">
              <button
                type="button"
                onClick={() => setActiveTab("registration")}
                className="group inline-flex items-center justify-center gap-2 rounded-xl bg-white px-6 py-3.5 font-bold text-[#014864] shadow-lg transition hover:-translate-y-1 hover:bg-cyan-50"
              >
                Alumni Registration
                <ArrowRight size={18} className="transition group-hover:translate-x-1" />
              </button>
              <button
                type="button"
                onClick={() => setActiveTab("directory")}
                className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/35 bg-white/10 px-6 py-3.5 font-bold text-white backdrop-blur transition hover:-translate-y-1 hover:bg-white/20"
              >
                <GraduationCap size={19} />
                Explore Alumni
              </button>
            </div>
          </div>
        </motion.div>

        <motion.div
          aria-hidden="true"
          animate={{ y: [0, -12, 0], rotate: [0, 4, 0] }}
          transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
          className="absolute -bottom-8 left-[8%] hidden h-24 w-24 rounded-3xl border border-white/20 bg-white/10 backdrop-blur md:block"
        />
        <motion.div
          aria-hidden="true"
          animate={{ y: [0, 14, 0], rotate: [0, -5, 0] }}
          transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
          className="absolute right-[10%] top-16 hidden h-16 w-16 rounded-2xl border border-white/20 bg-white/10 backdrop-blur md:block"
        />
      </section>

      {/* Main navigation and content */}
      <section className="relative mx-auto grid w-full max-w-7xl min-w-0 gap-6 overflow-hidden px-4 py-10 sm:px-6 md:py-14 lg:grid-cols-[290px_minmax(0,1fr)]">
        {/* Navigation */}
        <aside className="h-fit w-full min-w-0 max-w-full rounded-2xl border border-slate-200 bg-white p-3 shadow-sm lg:sticky lg:top-24">
          <div className="px-3 pb-3 pt-2">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-cyan-700">
              OCSAR Navigation
            </p>
            <h2 className="mt-1 text-lg font-extrabold text-slate-800">
              Explore the Office
            </h2>
          </div>

          <nav aria-label="OCSAR sections" className="w-full min-w-0 max-w-full">
            <ul className="flex w-full min-w-0 max-w-full flex-nowrap gap-2 overflow-x-auto overscroll-x-contain pb-2 touch-pan-x [scrollbar-width:thin] lg:flex-col lg:overflow-visible lg:pb-0">
              {tabs.map((tab) => {
                const selected = activeTab === tab.id;
                return (
                  <li key={tab.id} className="w-auto min-w-max flex-none lg:w-full lg:min-w-0">
                    <button
                      type="button"
                      onClick={() => setActiveTab(tab.id)}
                      aria-current={selected ? "page" : undefined}
                      className={`group relative flex w-auto min-w-max items-center gap-3 rounded-xl px-4 py-3 text-left text-sm font-semibold transition duration-200 lg:w-full lg:min-w-0 ${
                        selected
                          ? "bg-[#014864] text-white shadow-md shadow-cyan-900/15"
                          : "text-slate-600 hover:bg-cyan-50 hover:text-[#014864]"
                      }`}
                    >
                      <span
                        className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg transition ${
                          selected
                            ? "bg-white/15 text-cyan-100"
                            : "bg-slate-100 text-slate-500 group-hover:bg-cyan-100 group-hover:text-[#014864]"
                        }`}
                      >
                        {tab.icon}
                      </span>
                      <span className="whitespace-nowrap lg:whitespace-normal">
                        {tab.label}
                      </span>
                      {selected && (
                        <motion.span
                          layoutId="ocsar-active-tab"
                          className="absolute inset-y-2 left-0 w-1 rounded-r-full bg-cyan-300"
                        />
                      )}
                    </button>
                  </li>
                );
              })}
            </ul>
          </nav>
        </aside>

        {/* Active content */}
        <motion.main
          key={activeTab}
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className="min-w-0 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
        >
          <div className="border-b border-slate-100 bg-gradient-to-r from-cyan-50/80 to-white px-5 py-5 sm:px-8">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#014864] text-cyan-100 shadow-sm">
                {tabs.find((tab) => tab.id === activeTab)?.icon}
              </span>
              <div className="min-w-0">
                <p className="text-xs font-bold uppercase tracking-[0.16em] text-cyan-700">
                  University of Creative Technology Chittagong
                </p>
                <h2 className="mt-1 text-xl font-extrabold text-slate-800 sm:text-2xl">
                  {tabs.find((tab) => tab.id === activeTab)?.label}
                </h2>
              </div>
            </div>
          </div>

          <div className="p-5 sm:p-8">
            <div className="prose prose-slate max-w-none prose-headings:text-[#014864] prose-a:text-cyan-700">
              {content[activeTab]}
            </div>
          </div>
        </motion.main>
      </section>

      <footer className="border-t border-slate-200 bg-white px-5 py-6 text-center text-sm text-slate-500">
        Office of Career Services and Alumni Relations (OCSAR) • UCTC
      </footer>
    </div>
  );
}
